import { ActionIcon, Tooltip } from '@mantine/core';
import { invalidate } from '@react-three/fiber';
import { variants } from '@uag/react-core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { InteractionMode } from 'app/modules/wallforming/components/scenes/types/interactionMode';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

const screenWidth = window.screen.width;

export const InteractionModeToggle = () => {
    const { t } = useTranslation();

    const { interactionMode, setInteractionMode } = usePlacementStore(
        useShallow((state) => ({
            interactionMode: state.interactionMode,
            setInteractionMode: state.setInteractionMode
        }))
    );

    const isPoiSelectionMode = useMemo(() => interactionMode === InteractionMode.POI_NAVIGATION, [interactionMode]);

    const handleOnToggle = () => {
        setInteractionMode(isPoiSelectionMode ? InteractionMode.DEFAULT : InteractionMode.POI_NAVIGATION);
        requestAnimationFrame(() => invalidate());
    };

    return (
        <Tooltip
            label={isPoiSelectionMode ? t('buttonDisablePoiSelectionMode') : t('buttonEnablePoiSelectionMode')}
            position="right"
            variant={variants.tooltip.right}
        >
            <ActionIcon
                className={`
                    ${!isPoiSelectionMode && 'bg-background-gray-ultra-light hover:bg-background-gray!'}
                    ${screenWidth >= 1920 ? 'action-icon-large' : 'action-icon-medium'}
                `}
                variant={isPoiSelectionMode ? variants.actionIcon.activated : undefined}
                onClick={handleOnToggle}
            >
                location_on
            </ActionIcon>
        </Tooltip>
    );
};
